module.exports = __webpack_public_path__ + "static/command.018dabd3b511b421cd3e0b4eb1a53227.svg";